import type { google } from '@alugha/ima';
import IconButton from '@mui/material/IconButton';
import { PauseIcon } from '@phosphor-icons/react/Pause';
import { PlayIcon } from '@phosphor-icons/react/Play';
import { useTranslation } from 'react-i18next';

type PlayPauseButtonProps = {
  isPaused: boolean;
  manager: google.ima.AdsManager | null;
};

export function PlayPauseButton({ isPaused, manager }: PlayPauseButtonProps) {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!manager) {
      return;
    }

    if (isPaused) {
      manager.resume();
    } else {
      manager.pause();
    }
  };

  return (
    <IconButton
      size="small"
      onClick={handleClick}
      aria-label={isPaused ? t('Resume') : t('Pause')}
      sx={{ color: theme => theme.palette.common.white }}
    >
      {isPaused ? <PlayIcon /> : <PauseIcon />}
    </IconButton>
  );
}
